export const styles = ({
    container: {
        display: 'flex',
        height: '100%'
    }
});
